/**
 * Workflow canvas constants
 * Centralized values for consistent behavior across components
 */

// Canvas layout constants
export const CANVAS_CONSTANTS = {
  // Start node positioning
  START_NODE_ID: '-1',
  START_NODE_POSITION: { x: 350, y: 0 },
  
  // Node dimensions
  NODE_WIDTH_VW: 0.15, // 15% of viewport width
  NODE_HEIGHT: 60,
  NODE_START_HEIGHT: 52,
  
  // Default viewport
  DEFAULT_VIEWPORT_WIDTH: 1200,
  
  // Edge styling
  EDGE_STROKE_WIDTH: 2,
  EDGE_STEM_LENGTH: 50,
  EDGE_LABEL_FONT_SIZE: 10,
  EDGE_LABEL_PADDING: 4,
  EDGE_LABEL_HEIGHT: 20,
  EDGE_LABEL_BORDER_RADIUS: 10,
  EDGE_LABEL_CHAR_WIDTH: 7, // Approximate character width for label sizing
  
  // Panel dimensions
  CONFIG_PANEL_WIDTH: 320, // w-80 in Tailwind = 20rem = 320px
} as const;

// Edge condition styles
export const EDGE_STYLES = {
  DEFAULT: {
    color: '#6b7280',
    labelColor: '#6b7280',
    bgColor: '#f3f4f6'
  },
  SUCCESS: {
    color: '#d4d4d4ff',
    labelColor: '#15803d',
    bgColor: '#dcfce7'
  },
  FAILURE: {
    color: '#d4d4d4ff',
    labelColor: '#dc2626',
    bgColor: '#fee2e2'
  },
  EMAIL_REPLY_RECEIVED: {
    color: '#d4d4d4ff',
    labelColor: '#1d4ed8',
    bgColor: '#dbeafe'
  },
  EMAIL_REPLY_TIMEOUT: {
    color: '#d4d4d4ff',
    labelColor: '#d97706',
    bgColor: '#fef3c7'
  },
  DATA_MATCH: {
    color: '#d4d4d4ff',
    labelColor: '#7c3aed',
    bgColor: '#ede9fe'
  },
  CLASSIFICATION_MATCH: {
    color: '#d4d4d4ff',
    labelColor: '#0891b2',
    bgColor: '#cffafe'
  },
  CONFIDENCE_THRESHOLD: {
    color: '#d4d4d4ff',
    labelColor: '#65a30d',
    bgColor: '#ecfccb'
  },
  ALWAYS: {
    color: '#d4d4d4ff',
    labelColor: '#22c55e',
    bgColor: '#bfffd6ff'
  }
} as const;

// Edge condition labels
export const EDGE_LABELS = {
  success: 'Success',
  failure: 'Failure',
  email_reply_received: 'Reply Received',
  email_reply_timeout: 'Timeout',
  data_match: 'Data Match',
  classification_match: 'Classification Match',
  confidence_threshold: 'Confidence Met',
  always: 'Always'
} as const;